export default __webpack_public_path__ + "static/media/0173.9805f8a3.png";